/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */

    save: "Save",
    /* Module special vocabulary */
    "rebit-accounts": {
        menu: {
            list: 'Accounts',
        },
        table_titles: {
            id: 'ID',
            holder: "Holder's name",
            currency: 'Currency',
            exchange: 'Exchange',
            cash: 'Cash',
            type: 'Type',
            bank: 'Bank / Exchange',
            network: 'Network',
            owner_operator: 'Operated by',
            status: 'Status',
            is_depositable: 'Depositable',
            description: 'Label',
            opening_balance: 'Opening Balance',
            real_balance: 'Actual Balance',
            ideal_balance: 'Ideal Balance',
            monthly_turnover_limit: 'Monthly Turnover Limit',
            created_at: 'Registered Time',
            updated_at: 'Update Time',
            setting: 'Edit',
        },
        auth_params: "Authentication parameters",
        total_balances: {
            index: "Accounts Balance",
            currency: "Currency",
            total_actual_balance: "Total actual balance",
            usdt_value: "USDT Value",
            nzd_value: "NZD Value",
            total: "Total",
        },
        bank_account_number: 'Bank Account Number',
        wallet_address: 'Wallet Address',
        create: 'Create an Account',
        edit: 'Edit an Account',
    },
    "wallet-addresses": {
        menu: {
            index: 'Wallet Addresses',
            create: 'New wallet address',
            list: 'Wallet Addresses'
        },
        table_titles: {
            id: 'ID',
            owner: 'Owner',
            address: 'Address',
            network: 'Network',
            is_active: 'Status',
            setting: 'Edit / Delete',
        },
        edit: 'Edit wallet address'
    }
}
